
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as houseOK3AUmkn939Yx3ScquClCWEwuISBMdCQz9ycORHBM_458Meta } from "/opt/atlassian/pipelines/agent/build/pages/house.vue?macro=true";
import { default as indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as travelCsWWBA3g7gvsAPIrkxXzP5WkhFxnStE5zoPg87RmVB8Meta } from "/opt/atlassian/pipelines/agent/build/pages/travel.vue?macro=true";
import { default as contact_45us8QrNdy9ZbS_45VlO_45cVEF_452heQMFfcHFo3PEYa9CULkLcMeta } from "/opt/atlassian/pipelines/agent/build/pages/contact-us.vue?macro=true";
import { default as maintenancegXT4KTiPqP_45IirE4qaa69WWZQ27G5_45TNZgindTD9AZQMeta } from "/opt/atlassian/pipelines/agent/build/pages/maintenance.vue?macro=true";
import { default as authenticateH7MQYuMQr_Q5dNdR0Hv_GTELeRxT_457m2Wq9cX5IOc3sMeta } from "/opt/atlassian/pipelines/agent/build/pages/authenticate.vue?macro=true";
import { default as _91_91slug_93_93HbgHyMaq3em7en_45BKyDkU1hDnHRSIYfj8OJaTntWWyQMeta } from "/opt/atlassian/pipelines/agent/build/pages/info/[[slug]].vue?macro=true";
import { default as profilegXGu0_RyAwSumQULB_g4jyyjkZLxYyHHnLeV7UDTlXQMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/profile.vue?macro=true";
import { default as _91_91vin_93_93H9lRZwjIFow0mLQ75coUizOToYn4ENOwH_45_45LBJX8VaQMeta } from "/opt/atlassian/pipelines/agent/build/pages/rca/[[registration_plate]]/[[vin]].vue?macro=true";
export default [
  {
    name: "house",
    path: "/house",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/house.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "travel",
    path: "/travel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/travel.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact-us.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/maintenance.vue")
  },
  {
    name: "authenticate",
    path: "/authenticate",
    meta: {"middleware":["guest"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/authenticate.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug?",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/info/[[slug]].vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/profile.vue")
  },
  {
    name: "rca-registration_plate-vin",
    path: "/rca/:registration_plate?/:vin?",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/rca/[[registration_plate]]/[[vin]].vue")
  }
]